<template>
    <div class="main-content " v-cloak>
        <div class="container">
            <div class="form-success" v-if="changedSuccessully">
                <div class="icon-success-big"></div>
                <div class="form-success-title">Successfully changed!</div>
                <p>Your password has been updated!</p>
            </div>
            <div class="form-container" v-else>
                <div class="form-wrapper">
                    <div class="form-hor">
                        <div class="form-col">
                            <custom-input
                                @change="set_value"
                                input_type="password"
                                :invalid="current_pw_error"
                                :value="current_pw"
                                hint="Hint! At least 12 characters"
                                error_msg="Error! Current password is not correct"
                                name="current_pw"
                                label="Old password"
                            ></custom-input>
                        </div>

                        <div class="form-col">
                            <custom-input
                                input_type="password"
                                @change="set_value"
                                :value="pw"
                                hint="Hint! At least 12 characters"
                                :invalid="pw_complexity_error"
                                error_msg="* New password must be at least 12 characters"
                                name="pw"
                                label="New password"
                            ></custom-input>
                        </div>

                        <div class="form-col">
                            <custom-input
                                @change="set_value"
                                input_type="password"
                                hint="Hint! At least 12 characters"
                                :invalid="passwords_do_not_match_error"
                                :value="pw_again"
                                error_msg="* Passwords don't match"
                                name="pw_again"
                                label="Confirm new password"
                            ></custom-input>
                        </div>

                        <a
                            @click="changePassword"
                            href="javascript:{}"
                            :class="{ 'btn btn-primary': true, disabled: isDisabled }"
                            >Save</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import dropdown from "@/components/pages/dropdown.vue";
import customInput from "@/components/pages/custom-input.vue";
import settings from "@/settings";
import axios from "axios";

export default {
    name: "change-psw",
    components: { dropdown, customInput },
    data() {
        return {
            is_trial: true,
            errors: [],
            isDisabled: true,
            changedSuccessully: false,
            current_pw_error: false,
            pw_complexity_error: false,
            passwords_do_not_match_error: false,
            pw: null,
            current_pw: null,
            pw_again: null
        };
    },
    computed: {},
    watch: {
        current_pw() {
            this.validate();
        },
        pw() {
            this.validate();
        },
        pw_again() {
            this.validate();
        }
    },
    methods: {
        ...mapActions(["delete_user"]),
        validate() {
            this.current_pw_error = false;
            this.pw_complexity_error = false;
            this.passwords_do_not_match_error = false;
            if (
                this.current_pw &&
                this.current_pw.length > 0 &&
                this.pw &&
                this.pw_again &&
                this.pw === this.pw_again
            ) {
                this.isDisabled = false;
                return true;
            } else {
                this.isDisabled = true;
                return false;
            }
        },
        async changePassword() {
            if (this.pw !== this.pw_again) {
                this.passwords_do_not_match_error = true;
                return;
            }
            try {
                let result = await axios.post(settings.api_url + "/user/", {
                    current_pw: this.current_pw,
                    action: "update_password",
                    pw: this.pw
                });
                if (result && result.data && result.data.success === 1) {
                    this.pw = null;
                    this.pw_again = null;
                    this.current_pw = null;
                    this.changedSuccessully = true;
                }
            } catch (errorResponse) {
                if (errorResponse.data.errors.message === "current_user_not_found") {
                    this.current_pw_error = true;
                } else {
                    this.pw_complexity_error = true;
                }
            }
        },
        set_value(args) {
            this[args.prop_name] = args.prop_value;
        }
    },
    mounted() {},
    created() {}
};
</script>
<style scoped>
@media (max-width: 82rem) {
    .main-content {
        padding: 4rem 1.6rem 0 1.6rem;
    }
}

.btn-primary {
    padding: 0.8rem 1.6rem;
    margin-left: auto;
    align-items: flex-start; /* NEW */
    margin-bottom: 4.2rem;
}

.form-success {
    margin-top: 1.2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-success-title {
    margin-top: 1.2rem;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    color: #000000;
}

.form-success p {
    margin-top: 0.8rem;
    font-size: 1.2rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    color: #717171;
}

.form-hor .form-col {
    margin: 0;
}

.form-hor {
    flex: 1;
    flex-direction: column;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

.form-wrapper {
    display: flex;
}
</style>
